/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useState, useEffect, createContext } from 'react';

// export the ThemeContext
export const ThemeContext = createContext();


// ThemeContext Provider
export default ({ children }) => {

    const [colors, setColors] = useState({
        // primaryGreen: "#01E8AC",
        // primaryGreenLight: "#00CC97",
        // primaryGreenDark: "#008C68",
        primary: "#384E73",
        warning: "#ff6700",
        danger: "#9F1D1D",
        newPrimary:"#70B646",

       

        white: "#FFFFFF"
    })

    const [fontFamily, setFontFamily] = useState({
        primary: "Montserrat, sans-serif"
    })

    const [fontSize, setFontSize] = useState({
        xxxl:"2rem",
        xxl: "1.8rem",
        xl: "1.5rem",
        lg: "1.2rem",
        md: "1rem",
        md_sm: "0.9rem",
        sm: "0.8rem"
    })

    const [fontWeight, setFontWeight] = useState({
        regular: "400",
        medium: "500",
        semiBold: "600",
        bold: "700"
    })



    const [theme, setTheme] = useState({
        buttonTooltip: {
            position: 'relative',
            display: 'inline-block',
            tooltipText: {
              visibility: 'hidden',
              width: '120px',
              backgroundColor: '#555',
              color: '#fff',
              textAlign: 'center',
              padding: '5px 0',
              borderRadius: '6px',
              position: 'absolute',
              zIndex: 1,
              bottom: '125%',
              left: '50%',
              marginLeft: '-60px',
              opacity: 0,
              transition: 'opacity 0.3s',
            },
            tooltipTextAfter: {
              content: '""',
              position: 'absolute',
              top: '100%',
              left: '50%',
              marginLeft: '-5px',
              border: '5px solid transparent',
              borderColor: '#555 transparent transparent transparent',
            },
        },
        psychometricTestFooter: {
            backgroundColor: 'white',
            color: 'green',
            padding: '10px 20px',
            textAlign: 'right',
            fontSize: '0.8rem',
            fontFamily: "'Montserrat', sans-serif",
            fontWeight: 800,
        },
        segmentedButton: {
            group: {
                border: '1px solid black',
                borderRadius: '25px',
                overflow: 'hidden'
            },
            button: {
                base: {
                    borderRadius: '25px',
                    border: 'none',
                    position: 'relative',
                    paddingRight: '30px'
                },
                active: {
                    backgroundColor: '#28a745',
                    color: 'white'
                },
                inactive: {
                    backgroundColor: 'white',
                    color: 'black'
                },
                leftButton: {
                    borderRadius: '25px 0 0 25px'
                },
                rightButton: {
                    borderRadius: '0 25px 25px 0'
                },
                checkmark: {
                    position: 'absolute',
                    right: '10px',
                    top: '50%',
                    transform: 'translateY(-50%)'
                }
            }
        },
        homeTitle: {
            fontFamily: fontFamily.primary,
            fontSize: "2rem"
        },

        heading: {
            marginTop: "5px",
            fontFamily: fontFamily.primary,
            fontSize: fontSize.lg,
            fontWeight: fontWeight.semiBold,
            color: colors.primary
        },

        headingMedium: {
            marginTop: "5px",
            fontFamily: fontFamily.primary,
            fontSize: fontSize.lg,
            fontWeight: fontWeight.medium,
            color: colors.primary
        },

        headingXXL: {
            fontFamily: fontFamily.primary,
            fontSize: fontSize.xxl,
            fontWeight: fontWeight.medium
        },

        headingRegular: {
            fontFamily: fontFamily.primary,
            fontSize: fontSize.lg,
            fontWeight: fontWeight.regular
        },

        headingBold: {
            fontFamily: fontFamily.primary,
            fontSize: fontSize.lg,
            fontWeight: fontWeight.bold
        },

        headingBoldPrimaryColor: {
            fontFamily: fontFamily.primary,
            fontSize: fontSize.lg,
            fontWeight: fontWeight.bold,
            color: colors.primary
        },

        headingSemiBold: {
            fontFamily: fontFamily.primary,
            fontSize: fontSize.lg,
            fontWeight: fontWeight.semiBold
        },

        subHeadingSemibold: {
            fontFamily: fontFamily.primary,
            fontSize: fontSize.md,
            fontWeight: fontWeight.semiBold
        },

        h3headingSemibold: {
            fontFamily: fontFamily.primary,
            fontSize: fontSize.md,
            fontWeight: fontWeight.semiBold
        },

        paragraphHeading: {
            fontFamily: fontFamily.primary,
            fontSize: fontSize.md,
            fontWeight: fontWeight.semiBold
        },
        newParagraph: {
            fontFamily: fontFamily.primary,
            fontSize: fontSize.lg,
            fontWeight: fontWeight.semiBold,
            color:"#70B646"
        },

        paragraph: {
            fontFamily: fontFamily.primary,
            fontSize: fontSize.sm
        },

        paragraphMedium: {
            fontFamily: fontFamily.primary,
            fontSize: fontSize.sm,
            fontWeight: fontWeight.medium
        },

        paragraphMDSM: {
            fontFamily: fontFamily.primary,
            fontSize: fontSize.md_sm
        },


        card: {
            boxShadow: "0px 0px 5px #b4b4b4",
            borderRadius: "10px",
            border: "none",
            height: "100%"
        },

        cardTitle: {
            fontFamily: fontFamily.primary,
            fontSize: fontSize.xl,
            fontWeight: fontWeight.medium,
            color: colors.primary
        },

        cardParagraph: {
            fontFamily: fontFamily.primary,
            fontSize: fontSize.md
        },


        summaryCard: {
            borderRadius: "10px",
            border: "none",
            backgroundColor: colors.primary
        },

        summaryCardTitle: {
            color: "white",
            fontSize: fontSize.lg,
            fontWeight: fontWeight.semiBold
        },

        summaryCardValue: {
            color: "white",
            fontSize: fontSize.md,
            fontWeight: fontWeight.medium
        },

        selectedSlotCard: {
            cursor: "pointer",
            boxShadow: "0px 0px 5px #b4b4b4",
            borderRadius: "10px",
            border: "5px solid #384E73"
        },

        extraSlotCard: {
            // borderTop: "1px solid #000",
            // borderBottom: "1px solid #000",
            // backgroundColor: "#ededed"
        },

        disabledSlotCard: {
            backgroundColor: "#F0F0F0",
            boxShadow: "0px 0px 5px #b4b4b4",
            borderRadius: "10px",
            border: "none"
        },

        slotCard: {
            cursor: "pointer",
            boxShadow: "0px 0px 5px #b4b4b4",
            borderRadius: "10px",
            border: "none"
        },

        buttonRounded: {
            borderRadius: "50px",
            fontFamily: fontFamily.primary,
            fontSize: fontSize.md,
            fontWeight: fontWeight.bold,
            color: colors.white,
            backgroundColor: colors.primary
        },
        newButtonRounded: {
            borderRadius: "40px",
            fontFamily: fontFamily.primary,
            fontSize: fontSize.md,
            fontWeight: fontWeight.bold,
            color: colors.white,
            backgroundColor: "#70B646",
            border:"none",
            width:"75px",
            height:"40px"
        },

        button: {
            fontFamily: fontFamily.primary,
            fontSize: fontSize.md,
            fontWeight: fontWeight.bold,
            color: colors.white,
            backgroundColor: colors.primary
        },

        buttonDanger: {
            fontFamily: fontFamily.primary,
            fontSize: fontSize.md,
            fontWeight: fontWeight.bold,
            color: colors.white,
            backgroundColor: colors.danger
        },

        buttonWarning: {
            fontFamily: fontFamily.primary,
            fontSize: fontSize.md,
            fontWeight: fontWeight.bold,
            color: colors.white,
            backgroundColor: colors.warning
        },

        generalNavButton: {
            fontFamily: fontFamily.primary,
            fontWeight: fontWeight.semiBold,
            color: colors.white,
            backgroundColor: "#384E73",
            borderRadius: "50px"
        },

        newGeneralNavButton: {
            fontFamily: fontFamily.primary,
            fontWeight: fontWeight.semiBold,
            color: colors.white,
            backgroundColor: "#238636",
            borderRadius: "50px"
        },

        homeAction: {
            padding: "0 1rem",
            marginTop: "3rem",
            fontFamily: fontFamily.primary,
            fontSize: "2rem",
            fontWeight: fontWeight.semiBold,
            color: colors.white,
            backgroundColor: "#384E73",
            borderRadius: "50px"
        },

        newHomeAction: {
            padding: "0 1rem",
            marginTop: "3rem",
            fontFamily: fontFamily.primary,
            fontSize: "1.5rem",
            fontWeight: fontWeight.semiBold,
            color: colors.white,
            backgroundColor: "#70B646",
            borderRadius: "50px"
        },

        newParagraphHeading: {
            fontFamily: fontFamily.primary,
            fontSize: fontSize.xxxl,
            fontWeight: fontWeight.semiBold,
            color: "#70B646"
        },

        navbarItem: {
            fontFamily: fontFamily.primary,
            fontWeight: fontWeight.semiBold
        },

        // form Theme
        formTag: {
            marginLeft: "5px",
            backgroundColor: colors.primary,
            color: colors.white,
            padding: "5px"
        },
        formBodyText: {
            fontFamily: fontFamily.primary,
            fontSize: fontSize.md,
            fontWeight: fontWeight.medium
        },
        formInput: {
            fontFamily: fontFamily.primary
        },
        formSubmit: {
            borderRadius: "10px",
            fontFamily: fontFamily.primary,
            fontSize: fontSize.lg,
            fontWeight: fontWeight.semiBold,
            color: colors.white,
            backgroundColor: colors.primary
        },
        formButton: {
            borderRadius: "10px",
            fontFamily: fontFamily.primary,
            fontSize: fontSize.sm,
            fontWeight: fontWeight.semiBold,
            color: colors.white,
            backgroundColor: colors.primary
        },
        formButtonDanger: {
            borderRadius: "10px",
            fontFamily: fontFamily.primary,
            fontSize: fontSize.sm,
            fontWeight: fontWeight.semiBold,
            color: colors.white,
            backgroundColor: colors.danger
        },
        form: {
            borderStyle: "solid",
            borderColor: "#B7B7B7",
            borderWidth: "2px",
            borderRadius: "20px"
        },

        maintenanceTimer: {
            height: "4.5rem",
            width: "4.5rem",
            textAlign: "center",
            marginRight: "0.5rem"
        },
        maintenanceTimerSubDiv: {
            fontSize: "14px"
        },

    
        psychometricLanding: {
            container: {
                display: 'flex',
                justifyContent: 'center',
                gap: '2rem',
                padding: '2rem',
                flexWrap: 'wrap'
            },
            box: {
                flex: '1 1 300px',
                maxWidth: '500px',
                margin: '1rem'
            },
            boxContent: {
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '2rem'
            },
            content: {
                textAlign: 'center'
            },
            button: {
                width: 'auto',
                minWidth: '150px',
                padding: '0.5rem 2rem'
            }
        }

    });




    return (
        <div>

            <ThemeContext.Provider value={{ theme, colors, fontSize, fontWeight, fontFamily }}>
                {children}
            </ThemeContext.Provider>

        </div>

    )
}